export const S2_PREFIX_CLS = 'antv-s2';
